import { useEffect, useState } from 'react';
import { bridge } from 'shared/src/utils';
import { useGoodsSno } from '../../../hooks/useGoodsSno';

export const useLogViewGoodsOptionModal = (params: {
  mode: 'purchase' | 'gift';
}) => {
  const sno = useGoodsSno();
  const [isLogged, setIsLogged] = useState(false);
  useEffect(() => {
    if (isLogged) return;
    bridge.logAnalyticsEvent({
      name: 'VIEW_GOODS_OPTION_MODAL',
      analytics: {
        FROM_BUTTON: 'PURCHASE_BUTTON',
        GOODS_SNO: sno.toString(),
        EVENT_TYPE: 'VIEW_GOODS_OPTION_MODAL',
        SCREEN: 'GOODS_DETAIL',
        ...(params.mode === 'gift' ? { KIND: 'GIFT' } : {}),
      },
    });

    setIsLogged(true);
  }, [isLogged, params.mode, sno]);
};
